import React, { useState } from 'react';
import { HelpLabel } from './AdminHelp';
import { toast } from 'react-hot-toast';
import adminOperationsService from '../../services/adminOperationsService';

const AdminLoginPrompt = ({ onSuccess }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await adminOperationsService.login(credentials);
      toast.success('Admin session verified');
      onSuccess?.();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4 py-16 text-slate-100">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-8 shadow-2xl shadow-black/30">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-400">Restricted operations</p>
          <h1 className="mt-3 text-3xl font-bold">Exchange administration</h1>
          <p className="mt-2 text-sm leading-6 text-slate-400">
            Staff sign-in
          </p>
        </div>
        <form className="space-y-5" onSubmit={handleSubmit}>
          <HelpLabel resource="login" name="username" className="block text-sm font-medium text-slate-300">
            Username or email
            <input autoComplete="username" autoFocus required value={credentials.username}
              onChange={(event) => setCredentials((current) => ({ ...current, username: event.target.value }))}
              className="mt-2 w-full rounded-lg border border-slate-700 bg-slate-950 px-4 py-3 text-slate-100 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20" />
          </HelpLabel>
          <HelpLabel resource="login" name="password" className="block text-sm font-medium text-slate-300">
            Password
            <input autoComplete="current-password" required type="password" value={credentials.password}
              onChange={(event) => setCredentials((current) => ({ ...current, password: event.target.value }))}
              className="mt-2 w-full rounded-lg border border-slate-700 bg-slate-950 px-4 py-3 text-slate-100 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20" />
          </HelpLabel>
          {error && <div role="alert" className="rounded-lg border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-300">{error}</div>}
          <button className="w-full rounded-lg bg-cyan-500 px-4 py-3 font-semibold text-slate-950 transition hover:bg-cyan-400 disabled:cursor-not-allowed disabled:opacity-60"
            disabled={submitting} type="submit">
            {submitting ? 'Verifying…' : 'Open admin console'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPrompt;
